import React from 'react'
import styles from './UIGameEndHeader.module.scss'
import {AdBox} from './AdBox'
import {Logo} from './Logo'
import {FADE_IN_ANIMATION_DELAYS} from '../constants'
import {FadeInContainer} from '../../../common/FadeInContainer'
import {MapReplayButton} from './ActionButtons/MapReplayButton'
import {ShareButton} from './ActionButtons/ShareButton'
import {ReplayControlsShareButton} from '../../UIGameReplayControls/ReplayControlsContent/ShareButton/ReplayControlsShareButton'

interface UIGameEndHeaderProps {
    disableAnimation: boolean
    onClickShareReplay: () => void
}

export function UIGameEndHeader({
    disableAnimation,
    onClickShareReplay,
}: UIGameEndHeaderProps) {
    return (
        <div className={styles.header}>
            <FadeInContainer
                animationDelayMs={FADE_IN_ANIMATION_DELAYS.ads}
                animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
                disableAnimation={disableAnimation}
                className={styles.leftFadeInContainer}
                id='endgame-item-box'>
                <AdBox className={styles.adBox}/>
                <MapReplayButton text='strings:game.endGame.cornerButton.map' className={styles.leftMapReplayButtonContainer}/>
            </FadeInContainer>
            <Logo disableAnimation={disableAnimation}/>
            <FadeInContainer
                animationDelayMs={FADE_IN_ANIMATION_DELAYS.topLeftButtons}
                animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
                disableAnimation={disableAnimation}>
                <div className={styles.rightActionButtonsContainer}>
                    <MapReplayButton text='strings:game.endGame.cornerButton.mapWithReplay'/>
                    <ShareButton />
                </div>
                <div className={styles.rightShareButtonContainer}>
                    <ReplayControlsShareButton onShare={onClickShareReplay} />
                </div>
            </FadeInContainer>
        </div>
    )
}
